import { g17ecoApi, transformResponse } from './g17ecoApi';
import config from '../config';

export const serverStreamApi = g17ecoApi
  .injectEndpoints({
    endpoints: (builder) => ({
      // Create a short-lived cookie to initiate the stream
      setAuthToken: builder.mutation<void, void>({
        query: () => {
          return {
            url: 'auth/set-short-lived-cookie',
            method: 'post',
            data: { cookie: true },
            withCredentials: true,
          };
        },
      }),
      streamSurveyJob: builder.query<string[], { initiativeId: string; surveyId: string; jobId: string }>({
        transformResponse,
        query: ({ initiativeId, surveyId, jobId }) => {
          return {
            url: `initiatives/${initiativeId}/streaming/survey/${surveyId}/auto-answer/${jobId}`,
            method: 'get',
          };
        },
        async onCacheEntryAdded({ initiativeId, surveyId, jobId }, { updateCachedData, cacheEntryRemoved }) {
          const evtSource = new EventSource(`${config.apiUrl}initiatives/${initiativeId}/streaming/survey/${surveyId}/auto-answer/${jobId}`);

          evtSource.onmessage = (event) => {
            let parsed: { timestamp: string; message: string };

            // Parse JSON separately to handle parse errors distinctly
            try {
              parsed = JSON.parse(event.data);
            } catch (parseError) {
              console.error('Failed to parse SSE message:', parseError, event.data);
              return;
            }

            // Update cache data
            try {
              updateCachedData((draft) => {
                if (!Array.isArray(draft)) {
                  console.error('SSE cache data structure corrupted - expected array');
                  return;
                }
                draft.push(parsed.message);
              });
            } catch (updateError) {
              console.error('Failed to update SSE cache:', updateError);
            }
          };

          evtSource.onerror = (err) => {
            console.error('SSE connection error:', err);
            evtSource.close();
          };

          await cacheEntryRemoved;
          evtSource.close();
        },
      }),
    }),
  });

export const {
  useSetAuthTokenMutation,
  useStreamSurveyJobQuery,
} = serverStreamApi;
